module.exports = __webpack_public_path__ + "images/liinilaevad/apple-icon-120x120.png";